<div>
  <table class="custom-table-list" aria-label="supporting_document_type_table">
    <thead>
      <tr class="custom-table-list-headings">
        <th class="custom-col-width-30" scope="col">Name</th>
        <th class="custom-col-width-50" scope="col">Description</th>
        <th class="custom-col-width-20 th-last" scope="col">Action</th>
      </tr>
    </thead>
    <tbody>
      @for (supportingDocumentType of supportingDocumentTypes; track supportingDocumentType) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-30">{{ supportingDocumentType.name }}</td>
          <td class="custom-col-width-50">{{ supportingDocumentType.description || "-" }}</td>
          <td class="custom-col-width-20 td-last">
            @if (hasEditAccess()) {
              <span class="d-flex justify-content-start">
                <span data-bs-toggle="tooltip" ngbTooltip="Edit" [placement]="'left'"
                  (click)="isEditSupportingDocumentType(supportingDocumentType)">
                  <div tooltipClass="custom-tooltip" class="btn btn-primary btn-sm me-2 custom-button">
                    <fa-icon [icon]="faEdit"></fa-icon>
                  </div>
                </span>
                <span data-bs-toggle="tooltip" ngbTooltip="DELETE" [placement]="'left'"
                  (click)="deleteSupportingDocumentType(supportingDocumentType)">
                  <div class="btn btn-primary btn-sm me-2 fa-icon-class custom-button">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </div>
                </span>
              </span>
            }
          </td>
        </tr>
      }
      @if (loadRecords) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-100 text-danger d-flex justify-content-center">
            <app-common-icon [loadingIcon]="loadRecords"></app-common-icon>
          </td>
        </tr>
      }
      @if (!loadRecords && supportingDocumentTypes.length === 0) {
        <tr>
          <td class="custom-col-width-100 text-danger d-flex justify-content-center">
            No Data Found
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div class="overlay" [class.show]="openSupportingDocumentTypePanel"></div>
@if (openSupportingDocumentTypePanel) {
  <div class="off-canvas width-450" [class.show]="openSupportingDocumentTypePanel">
    <div class="off-canvas-content">
      <app-add-supporting-document-type [isEdit]="isEdit" [selectedSupportingDocumentType]="selectedSupportingDocumentType"
        (successToster)="successTosterFromAddSupportingDocumentTypeComponent($event)"
      (closePanel)="closeSupportingDocumentTypePanel()"></app-add-supporting-document-type>
    </div>
  </div>
}

@if (isErrorToster) {
  <div class="toaster_message">
    <app-error-toaster [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-error-toaster>
  </div>
}

@if (isSuccessToster) {
  <div class="toaster_message">
    <app-toast [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-toast>
  </div>
}

<div class="footer-page-ination">
  <app-paginator [totalCount]="totalRecords" [showFirstLastIcon]="true" (selectedPage)="onPageChange($event)">
  </app-paginator>
</div>
